import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "htmlTranslationEditor"
};
const _hoisted_2 = {
  class: "referenceBlock"
};
const _hoisted_3 = {
  class: "referenceTitle"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "editorBlock"
};
const _hoisted_6 = {
  class: "editorTitle"
};
const _hoisted_7 = {
  class: "editorWrapper"
};
const _hoisted_8 = {
  class: "htmlTranslationFooter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_tiny_mce = _resolveComponent("w-tiny-mce");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.visible,
    title: _ctx.$t('speachTranslation.manage.htmlEditor.title'),
    width: '960px',
    "close-on-outside-click": false,
    onOnDialogClose: _ctx.onCancel
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('speachTranslation.manage.htmlEditor.cancel'),
      onAction: _ctx.onCancel
    }, null, 8, ["label", "onAction"]), _createVNode(_component_standard_button, {
      loading: _ctx.saving,
      disabled: _ctx.saving,
      label: _ctx.$t('speachTranslation.manage.htmlEditor.save'),
      onAction: _ctx.onSave
    }, null, 8, ["loading", "disabled", "label", "onAction"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('speachTranslation.manage.htmlEditor.sourceLabel')) + " (" + _toDisplayString(_ctx.originalLangLabel) + ")", 1), _createElementVNode("div", {
      class: "referenceContent",
      innerHTML: _ctx.sourceHtml || '—'
    }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('speachTranslation.manage.htmlEditor.translationLabel')) + " (" + _toDisplayString(_ctx.targetLangLabel) + ")", 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_w_tiny_mce, {
      editorId: _ctx.editorId,
      customConfig: _ctx.editorConfig,
      text: _ctx.initialHtml,
      "display-editor-buttons": false,
      onBlur: _ctx.onEditorContent
    }, null, 8, ["editorId", "customConfig", "text", "onBlur"])])])])]),
    _: 1
  }, 8, ["visible", "title", "onOnDialogClose"]);
}